import React from 'react';

const PermissionsInfo = () => (
  <div>
    <h5>What are Permissions?</h5>
    <p>
      An Access Control List (ACL) model is used to limit access to Dashboard Folders. A user or a Team can be assigned
      permissions for a folder or for a single dashboard.
    </p>
  </div>
);

export default PermissionsInfo;
